<script setup lang="ts">
import { Building2, Users } from 'lucide-vue-next';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { SegmentedToggle } from '@/components/ui/segmented-toggle';
import { TenantType } from '@/config/constants/enums';

const { t } = useI18n();

withDefaults(defineProps<{ fullWidth?: boolean }>(), { fullWidth: false });

const model = defineModel<TenantType>({ required: true });

const options = computed(() => [
    { value: TenantType.SUPPLIER, label: t('home.toggle.supplier'), icon: Building2 },
    { value: TenantType.AGENT, label: t('home.toggle.agent'), icon: Users },
]);
</script>

<template>
    <SegmentedToggle v-model="model" :options="options" :full-width="fullWidth" active-color="bg-orange-500 shadow-orange-500/25" />
</template>
